import type { TSerializedWidget } from 'src/entities/workspace/types';
import { mergeReferenceWellsIntoSerializedWidget } from 'src/packages/reference-wells-persistence/merge-reference-wells-into-serialized-widget';
import type {
  TWellCorrelationSerializedInternalState,
  WellCorrelationWidgetEntity,
} from 'src/pages/dashboard/features/well-correlation-widget/WellCorrelationWidget.entity';

export function serializeWellCorrelationWidget(widget: WellCorrelationWidgetEntity): TSerializedWidget {
  const internalState: TWellCorrelationSerializedInternalState = {
    wellId: widget.wellId,
    stateParams: widget.stateParams,
  };

  const serialized: TSerializedWidget = {
    wellId: widget.wellId,
    uuid: widget.uuid,
    type: widget.type,
    groupId: widget.groupId,
    size: {
      w: widget.size.w,
      h: widget.size.h,
    },
    position: {
      x: widget.position.x,
      y: widget.position.y,
    },
    isFullscreen: widget.isFullscreen,
    internalState,
  };

  return mergeReferenceWellsIntoSerializedWidget(serialized, widget);
}
